/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  z as zod
} from 'zod'

/**
 * Create a new view
 */
export const tableViewCreateBody = zod.object({
  "name": zod.string().min(1),"visible_to": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"encoded_table_params": zod.string().min(1),"type": zod.enum(['transaction_table'])
})

/**
 * Returns all details about a given table view
 */
export const tableViewGetParams = zod.object({
  "viewId": zod.string()
})

export const tableViewGetResponseAnnotationsSetMin = 2;
export const tableViewGetResponseAnnotationsSetMax = 2;

export const tableViewGetResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(tableViewGetResponseAnnotationsSetMin).max(tableViewGetResponseAnnotationsSetMax)).optional(),"type": zod.enum(['transaction_table']),"id": zod.string().min(1),"name": zod.string().min(1),"visible_to": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"created_by": zod.string().min(1),"encoded_table_params": zod.string().min(1),"created_at": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional()
})

/**
 * Update a table view
 */
export const tableViewUpdateParams = zod.object({
  "viewId": zod.string()
})

export const tableViewUpdateBody = zod.object({
  "name": zod.string().min(1),"visible_to": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"encoded_table_params": zod.string().min(1)
})

export const tableViewUpdateResponseAnnotationsSetMin = 2;
export const tableViewUpdateResponseAnnotationsSetMax = 2;

export const tableViewUpdateResponse = zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(tableViewUpdateResponseAnnotationsSetMin).max(tableViewUpdateResponseAnnotationsSetMax)).optional(),"type": zod.enum(['transaction_table']),"id": zod.string().min(1),"name": zod.string().min(1),"visible_to": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"created_by": zod.string().min(1),"encoded_table_params": zod.string().min(1),"created_at": zod.string().regex(new RegExp(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)).or(zod.union([zod.null(), zod.literal("")])).optional()
})

/**
 * Delete a given table view
 */
export const tableViewDeleteParams = zod.object({
  "viewId": zod.string()
})

